//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        files: Array,
        readonly: Boolean,
        nameFn: Function,
        progressFn: Function,
        hasErrorFn: Function,
        canDownloadFn: Function,
        downloadFn: Function,
        removeFn: Function,
    },

    methods: {
        getLabel(file) {
            if (this.hasErrorFn(file))
                return this.nameFn(file);

            const p = this.getProgress(file);

            if (p == null)
                return this.nameFn(file);

            return `${Math.round(this.getProgress(file) * 100)} %`;
        },
        getProgress(file) {
            return this.progressFn && this.progressFn(file);
        },
        canDownload(file) {
            return this.getProgress(file) == null && !this.hasErrorFn(file) && this.canDownloadFn(file);
        },
        download(file) {
            if (this.canDownload(file)) {
                this.downloadFn(file);
            }
        },
    },
};
